
<!--  document details modal -->
<div class="modal fade" id="viewImage" tabindex="-1" role="dialog" aria-labelledby="viewImage" aria-hidden="true"
data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-xl" role="document" style="height:calc(100vh - 56px);">
    <div class="modal-content" style="height: calc(100vh - 56px);overflow: hidden;">
      <button class="no-border-btn doc-close-btn" data-dismiss="modal">
        <img src="../../../../assets/images/cross-icon-3.svg" alt="cross-icon" width="24px" height="24px">
      </button>
      <div class="modal-body">
        <div class="row">
          <!-- <div class="col-12 details content-center img-zoom-container"
          (mouseenter)="imageZoom('docImage1', 'myresult');">
            <img [src]="samplePicture" alt="sample-picture" class="img-fluid" width="300" height="240"
             id="docImage1">
             <img class="img-zoom-result" id="myresult" alt="img-zoom-result" class="img-zoom-result">
          </div> -->
          <div class="content-center details" (mouseenter)="imageZoom('myimage', 'myresult');" style="margin:auto">
            <img id="myimage" [src]="samplePicture" class="img-fluid" alt="sample-picture" style="height: calc(100vh - 80px);">
            <div id="myresult" class="img-zoom-result"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>